/**
 * Build a stable per-subTheme `colorIdx` map for BarChart-family components.
 *
 * Sort all known subTheme docs by `_id` and assign sequential indices. BarChart
 * wraps internally on `dataVizColors.length` (12 colors), so each subTheme
 * gets its own distinct slot up to 12, then cycles. Anchoring the assignment
 * to the global metadata (not the currently visible groups) means colors
 * don't reshuffle when filters change which subThemes appear.
 *
 * Reserves a slot for the "ungrouped" bucket at the end so tags missing a
 * subTheme don't collide with any real subTheme's slot.
 */
export const buildSubThemeColorIdxMap = (subThemeDocs) => {
  const map = {};
  const sorted = [...(subThemeDocs || [])].sort((a, b) =>
    String(a._id) < String(b._id) ? -1 : String(a._id) > String(b._id) ? 1 : 0
  );
  sorted.forEach((st, i) => {
    map[st._id] = i;
  });
  map.__ungrouped__ = sorted.length;
  return map;
};
